const slick = require('/assets/js/slick/slick.js');
import '/assets/js/common.js';
import '/assets/css/slick/slick.css';
import '/assets/css/_common.scss';
import '/assets/css/about.scss';


// ===========================================
// スライドショー
// ===========================================
$(function () {
  $('.slideShow').each(function(){
    const slide = $(this);

    slide.slick({
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      slidesToShow: 2,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
      speed: 10000,
      responsive: [
      {
        breakpoint: 641, // 399px以下のサイズに適用
        settings: {
        slidesToShow: 1,
        },
      },
    ],
    });
  });
});